/** @jsx jsx */
import { jsx } from 'theme-ui'
import { EVEntry } from '../helpers/react'
import { Palette } from '../../utils/palette'

export default ({ children, entries, options }) => {
  const styling = {
    textAlign: 'center',
    display: 'flex',
    flexDirection: ['column', 'row'],
    justifyContent: 'space-evenly',
    alignItems: 'center',
    py: 'xs',
    margin: 'auto',
    variant: 'layout.flex-grid.container',
    '> *': {
      my: ['xs', 'inherit'],
    },
    '[class*="palette"]': {
      width: 'auto',
      '*': {
        my: [0, 'inherit'],
      },
    },
    img: {
      width: 'auto',
    },
    ...options,
  }

  const childrenArray = entries
    ? entries.map((entity, i) => <EVEntry {...entity} key={i} />)
    : children

  return (
    <Palette as='div' px={{ backgroundColor: 'backgroundColor' }}>
      <div sx={styling}>
        <For index='key' each='child' of={childrenArray}>
          <div key={key}>
            {/* eslint-disable-next-line react/jsx-no-undef */}
            <child.type {...child.props} />
          </div>
        </For>
      </div>
    </Palette>
  )
}
